import { Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';


import 'rxjs/add/operator/do';
@Injectable()


export class JwtInterceptor implements HttpInterceptor {
  constructor(private router:Router) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    return next.handle(request).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          console.log("redirect to the login route")
          alert("Your token has expired , Please Login again")
          localStorage.removeItem("authData");
          localStorage.removeItem("projectId");
          this.router.navigate(['/login']);
        }
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/_helpers/jwt.interceptor.ts